export const SHARE_MESSAGE = `Hey, I've gone solar and thought you might be interested. This is a link to the equipment powering my home. Check it out!`;
export const REFERRAL_MESSAGE = `Hey, I've gone solar and thought you might be interested. This is a link to my solar community. Check it out!`;
